import Vue from 'vue'
import Router from 'vue-router'
import Top from '@/components/Top'
import Companion from '@/components/Companion'
import Menu from '@/components/Menu'
import Service from '@/components/Service'
import Contact from '@/components/Contact'
import Detail from '@/components/Detail'
import Manager from '@/components/Manager'
import Delete from '@/components/manager/Delete'
import Update from '@/components/manager/Update'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Top',
      component: Top
    },
    {
      path: '/companion',
      name: 'Companion',
      component: Companion
    },
    {
      path: '/menu',
      name: 'Menu',
      component: Menu
    },
    {
      path: '/service',
      name: 'Service',
      component: Service
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/companion/detail',
      name: 'Detail',
      component: Detail
    },
    {
      path: '/manager',
      name: 'Manager',
      component: Manager
    },
    {
      path: '/manager/delete',
      name: 'Delete',
      component: Delete
    },
    {
      path: '/manager/update',
      name: 'Update',
      component: Update
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js